import { HomePage, BookingsPage, ProfilePage } from './pages';
import { withNavigationWatcher } from './contexts/navigation';
import BookingForm from './pages/bookings/bookingForm/bookingForm';
import PriceListPage from './pages/priceList/priceList';
import InfoPage from './pages/info/info';
import ContactPage from './pages/contact/contact';
import Drivers from './pages/drivers/drivers';
import Tutorial from './pages/tutorial/tutorial';
import Invoices from './pages/invoices/invoices';

const routes = [
    {
        path: '/bookings',
        element: BookingsPage
    },
    {
        path: '/bookings/new',
        element: BookingForm
    },
    {
        path: '/bookings/edit/:id',
        element: BookingForm
    },
    {
        path: '/bookings/view/:id',
        element: BookingForm
    },
    {
        path: '/bookings/copy/:id',
        element: BookingForm
    },
    {
        path: '/drivers',
        element: Drivers
    },
    {
        path: '/invoices',
        element: Invoices
    },
    {
        path: '/pricelist',
        element: PriceListPage
    },
    {
        path: '/info',
        element: InfoPage
    },
    {
        path: '/contact',
        element: ContactPage
    },
    {
        path: '/profile',
        element: ProfilePage
    },
    {
        path: '/home',
        element: HomePage
    },
    {
        path: '/tutorial',
        element: Tutorial
    }
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
